import { DownloadOutlined } from "@ant-design/icons"
import { Button, Flex, Tooltip } from "antd"

import tableStyles from "@/_styles/table.module.scss"
import variables from "@/_styles/variables.module.scss"
import { getFinanceDocument } from "@/http/financeDataRecord"

import { IFinanceDocument } from "@/types/IFinanceDataRecord"
import { ITableColumn } from "@/types/ui"

import { downloadFile } from "@/utils/download"
import { dateTimeFormat, formatDate } from "@/utils/formatDate"
import { getMoney } from "@/utils/formatNumber"


export const financeDocumentColumns: ITableColumn<IFinanceDocument>[] = [
  {
    title: "Дата",
    key: "date",
    dataIndex: ["date"],
    render: (_, { date }) => <span className={tableStyles["text-gray"]}>{date && <>{formatDate(date, dateTimeFormat)}</> }</span>,
    sorter: true,
    defaultSortOrder: "descend",
    width: 75,
    isVisible: true,
    order: 1
  },
  {
    title: "Номер",
    key: "number",
    dataIndex: ["number"],
    render: (_, { number }) => <span className={tableStyles["text-gray"]}>{number}</span>,
    sorter: true,
    width: 75,
    isVisible: true,
    order: 2
  },
  {
    title: "Тип документа",
    key: "documentType",
    dataIndex: ["documentTypeText"],
    render: (_, { number }) => <span className={tableStyles["text-bold"]}>{number}</span>,
    sorter: true,
    align: "center",
    width: 100,
    isVisible: true,
    order: 3
  },
  {
    title: "Контрагент",
    key: "customerId",
    dataIndex: ["customerName"],
    render: (_, { customerName }) => <span className={tableStyles["text-bold"]}>{customerName}</span>,
    align: "center",
    width: 120,
    sorter: true,
    isVisible: true,
    order: 4
  },
  {
    title: "Сумма",
    key: "amount",
    dataIndex: ["amount"],
    render: (_, { amount }) => <span className={tableStyles["text-summ"]}>{amount ? getMoney(amount) : "-"}</span>,
    sorter: true,
    width: 125,
    isVisible: true,
    order: 5
  },
  {
    title: "Договор",
    key: "contract",
    dataIndex: ["contract"],
    sorter: true,
    width: 175,
    isVisible: true,
    order: 6
  },
  {
    title: "Нефтебаза",
    key: "depotId",
    dataIndex: ["depotName"],
    render: (_, { depotName }) => <span className={tableStyles["text-bold"]}>{depotName ?? "-"}</span>,
    width: 50,
    sorter: true,
    isVisible: true,
    order: 7
  },
  {
    title: "Префикс",
    key: "prefix",
    dataIndex: ["prefix"],
    sorter: true,
    width: 25,
    isVisible: true,
    order: 8
  },
  {
    title: "Документ основание",
    key: "baseDocument",
    dataIndex: ["baseDocument"],
    sorter: true,
    width: 200,
    isVisible: true,
    order: 9
  },
  {
    title: "Скачать",
    key: "uid",
    render: (_: any, { id }) =>
      <>
        <Flex gap={10} align="center">
          <Tooltip title="Документ">
            <Button
              icon={<DownloadOutlined />}
              style={{ padding: 19, color: variables.basecolorlight, borderColor: variables.basecolorlight }}
              onClick={async (e) => {downloadFile(await getFinanceDocument(id))
                .then()
                e.preventDefault()
                e.stopPropagation()
              }}
            >
              Скачать
            </Button>
          </Tooltip>
        </Flex>
      </>,
    align: "left",
    width: 75,
    isVisible: true,
    order: 10
  }
]